import _ from 'lodash';
import React from 'react';

import {connect} from 'react-redux';
import {submit, isSubmitting, isInvalid, formValueSelector} from 'redux-form';

import {attachUuidKey} from 'utils/common';

import {
  fetchBooking,
  fetchRentScheduleSummary,
  fetchRentSchedule,
  MODALS
} from 'ducks/bookings';
import {fetchRentSchedule as fetchTenancyRentSchedule} from 'ducks/tenancy';
import {selectModal} from 'ducks/modals';
import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import {default as Modal, withModal} from 'components/Modal';

import {
  RentInfoSection,
  CreateRentScheduleForm,
  PaymentScheduleTable,
  Buttons
} from './components';

class CreateRentScheduleModal extends React.Component<any> {
  addUniqueIdentifierToEachInvoiceItem = schedule => {
    const invoiceItemsWithUuid = schedule.billingCycle.invoiceItems.map(
      attachUuidKey
    );

    return {
      schedule: {
        ...schedule,
        billingCycle: {
          invoiceItems: invoiceItemsWithUuid
        }
      }
    };
  };

  triggerFormSubmit = () => {
    const {data: {locationRef}} = this.props;
    this.props.requiresPermission(
      {
        locationRef,
        permission: PERMISSIONS.APPLY_PAYMENT_SCHEDULE
      },
      () => {
        this.props.submit('createRentSchedule');
      }
    );
  };

  applyRentScheduleExtraActions = () => {
    const {data: {bookingId, locationRef, tenancyId}} = this.props;

    return [
      ...this.props.closeModalExtraActions,
      () => fetchRentSchedule({bookingId}),
      () => fetchBooking({locationRef, bookingId}),
      () => fetchTenancyRentSchedule({tenancyId})
    ];
  };

  generateRentScheduleExtraActions = () =>
    this.props.storeDataExtraActions(this.addUniqueIdentifierToEachInvoiceItem);

  fetchRentScheduleSummary = () => {
    const {data: {bookingId}, rentFrequency, rentPerMonth} = this.props;

    return this.props.fetchRentScheduleSummary(
      {
        bookingId,
        rentFrequency,
        rentPerMonth
      },
      this.props.storeDataExtraActions(data => ({
        rentScheduleSummary: data
      }))
    );
  };

  render() {
    const {
      data: {period: {startDate, endDate}, schedule, generating},
      closeModal,
      rentScheduleSummary,
      form: {submitting, invalid}
    } = this.props;
    const submitButtonDisabled = submitting || invalid || _.isEmpty(schedule);

    return (
      <Modal
        className="CreateRentScheduleModal"
        show={true}
        onClose={closeModal}
        type={Modal.LARGE}>
        <Modal.Header heading="Create Rent Schedule" />
        <Modal.Body>
          <RentInfoSection
            startDate={startDate}
            endDate={endDate}
            rentScheduleSummary={rentScheduleSummary}
          />
          <CreateRentScheduleForm
            generateRentScheduleExtraActions={
              this.generateRentScheduleExtraActions
            }
            applyRentScheduleExtraActions={this.applyRentScheduleExtraActions}
            generating={generating}
            fetchRentScheduleSummary={this.fetchRentScheduleSummary}
          />
          {schedule && <PaymentScheduleTable schedule={schedule} />}
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={this.triggerFormSubmit}
            submitting={submitting && !generating}
            submitButtonDisabled={submitButtonDisabled}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const formSelector = formValueSelector('createRentSchedule');

const mapStateToProps = state => {
  const {data: {rentScheduleSummary}} = selectModal(
    state,
    MODALS.CREATE_RENT_SCHEDULE
  );

  return {
    rentFrequency: _.get(formSelector(state, 'billingFrequency'), 'value'),
    rentPerMonth: formSelector(state, 'rentPerMonth'),
    rentScheduleSummary: rentScheduleSummary || {},
    form: {
      invalid: isInvalid('createRentSchedule')(state),
      submitting: isSubmitting('createRentSchedule')(state)
    }
  };
};

const mapDispatchToProps = {
  submit,
  fetchRentScheduleSummary,
  requiresPermission
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.CREATE_RENT_SCHEDULE)(CreateRentScheduleModal)
);
